/** Available deal status types */
export enum DealStatusTypeEnum {
  /** Predefined "In Progress" status (can be only one per tenant) */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Predefined "Done" status (can be only one per tenant) */
  DONE = 'DONE',
  /** Predefined "Refused" status (can be only one per tenant) */
  REFUSED = 'REFUSED',
  /** Custom status (can be any number per tenant) */
  CUSTOM = 'CUSTOM',
}
